import { BreadcrumbsHeader } from 'components/molecules/BreadcrumbsHeader';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import { FC } from 'react';

import { Box, Divider, Grid, Typography } from '@mui/material';
import { IPet } from 'types/Pet';
import { PetTreatmentInformations } from 'components/molecules/pet/PetTreatmentInformations';
import { PetCard } from 'pages/Vet/Appointment/PetCard';

const pet = {
  name: 'Jack',
  birthDate: '10/15/1998',
  weight: 2.5,
  gender: '',
  specie: '',
  race: '',
  tutor: { name: 'Rogerinho' },
  castrated: true,
  temperament: '',
  observations: '',
  active: true,
  createdAt: '',
  updatedAt: '',
  lastTreatment: '',
  imageUrl:
    'https://www.mypetbrasil.com/blog/wp-content/uploads/2020/02/Aumente-as-vendas-no-seu-Pet-Shop.jpg',
  id: '1',
};
export const HistoricPet: FC = () => {
  //   if (!pet?.tutor || !pet._id) {
  //     return null;
  //   }

  return (
    <Grid container spacing={3}>
      <Grid container item spacing={2}>
        <Grid item xs={12}>
          <BreadcrumbsHeader
            items={[{ title: 'Meu Histórico' }, { title: 'Registros do Pet' }]}
          />
        </Grid>
      </Grid>

      <Grid container item marginTop={2}>
        <PaperCardTemplate>
          <Grid
            container
            spacing={2}
            marginBottom={4}
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
          >
            <Grid item xs="auto">
              <Typography
                display={'flex'}
                justifyContent="space-between"
                alignItems="center"
                sx={{ fontWeight: 400, fontSize: 18, pr: 2 }}
              >
                DADOS DO PET
              </Typography>
            </Grid>
            <Grid item xs>
              <Divider sx={{ borderColor: '#FBB45F', height: 1 }} />
            </Grid>
          </Grid>
          <Box display="flex" mb={2}>
            <PetCard image={pet.imageUrl} />
            <PetTreatmentInformations
              ml={4}
              pet={pet as unknown as IPet}
              tutorName={pet?.tutor?.name}
            />
          </Box>
        </PaperCardTemplate>
      </Grid>
    </Grid>
  );
};

